// @flow
import React from 'react'
import PropTypes from 'prop-types'

import './icon.scss'

export default function Icon(props) {
  const { type, size, onTouchStart, onClick, className } = props

  return (
    <div
      className={`ui-icon ${className}`}
      onTouchStart={onTouchStart}
      onClick={onClick}
      role="presentation">
      <i
        className={`ui-icon__inner ${type}`}
        // style={{ width: `${size / 7.5}vw`, height: `${size / 7.5}vw` }}
      />
    </div>
  )
}

Icon.defaultProps = {
  type: 'success',
  className: '',
  size: '20',
  onTouchStart: () => {},
  onClick: () => {}
}

Icon.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
  onTouchStart: PropTypes.func
}
